import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {IndexPage} from "./pages/IndexPage.tsx";
import {AddPage} from "./pages/AddPage.tsx";
import {EditPage} from './pages/EditPage.tsx';


export const SubscriptionsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListSubscriptions) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes(rbacActions.CreateSubscription) ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/subscriptions'/>
                    )
                }
            />

            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetSubscription) ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/subscriptions'/>
                    )
                }
            />

        </Routes>
    );
};


